import { ERegion } from 'shared/types/form';
import { EStatus } from 'shared/types/listing';

export const FILTER_REGIONS: Array<ERegion> = Object.values(ERegion);
export const FILTER_STATUSES: Array<EStatus> = Object.values(EStatus);
